<template>
    <div>
    </div>
</template>

<script>
    import tools from "../tools";

    export default {
        name: 'expoolRedirect',
        watch: {
            //如果路由发生了变化，更新页面数据
            $route(to, from) {
                if (to.path !== from.path) {
                    if (this.exercisePoolId != this.$route.params.exercisePoolId) {
                        this.exercisePoolId = this.$route.params.exercisePoolId;
                        this.genre = this.$route.params.genre;
                        this.Statu = this.$route.params.Statu;
                        this.init();
                    }
                }
            }
        },
        data() {
            return {
                exercisePoolId: this.$route.params.exercisePoolId,
                genre: this.$route.params.genre,
                Statu: this.$route.params.Statu, //1=已使用
                source: ''
            }
        },
        created() {
            let routeParams = tools.$_GET()
            if (routeParams.source != undefined) {
                this.source = routeParams.source
            }
            this.init();
        },
        updated() {
        },
        methods: {
            init() {
                //判断题库类型，跳转不同页面
                let _this = this;
                tools.api('ExercisesPool.IsExercisePoolTypeAsync', {"exercisePoolId": _this.exercisePoolId}, (data) => {
                    //（true：OCR录入、false：手动录入）
                    if (data) {
                        //判断是否有习题
                        tools.api('ExercisesPool.GetExercisePoolByIdAsync', {"exercisePoolId": _this.exercisePoolId}, (data) => {
                            let exercisePoolExcount = data.ExerciseCount;
                            if (_this.genre == 3 || _this.genre == 5) {
                                if (exercisePoolExcount > 0) {
                                    _this.$router.push("/ocr/expool/" + _this.exercisePoolId + "/" + _this.genre + "/" + _this.Statu + (_this.source != '' ? "?source=" + _this.source : ''));
                                } else {
                                    _this.$router.push("/ocr/expoolPicture/" + _this.exercisePoolId + "/" + _this.genre + "/" + _this.Statu);
                                }
                            } else {
                                if (exercisePoolExcount > 0) {
                                    _this.$router.push("/ocr/expool/" + _this.exercisePoolId + (_this.source != '' ? "?source=" + _this.source : ''));
                                } else {
                                    _this.$router.push("/ocr/expoolPicture/" + _this.exercisePoolId);
                                }
                            }
                        });
                    } else {
                        _this.$router.push("/expool/" + _this.exercisePoolId + (_this.source != '' ? "?source=" + _this.source : ''));
                    }
                });
            }
        }
    }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>